export const ACTION_TYPES = {
	ADMIN_SEARCH_CLEAR_DATA: 'ADMIN_SEARCH_CLEAR_DATA',
	ADMIN_SEARCH_HEADER_SORT: 'ADMIN_SEARCH_HEADER_SORT',
	ADMIN_SEARCH_INIT: 'ADMIN_SEARCH_INIT',
	ADMIN_SEARCH_LOADING: 'ADMIN_SEARCH_LOADING',
	ADMIN_SEARCH_ROWS: 'ADMIN_SEARCH_ROWS',
	ADMIN_SEARCH_ROWS_INDEX: 'ADMIN_SEARCH_ROWS_INDEX',
	ADMIN_SEARCH_ROW_TOGGLE: 'ADMIN_SEARCH_ROW_TOGGLE',
	ADMIN_SEARCH_ROWS_TOGGLE: 'ADMIN_SEARCH_ROWS_TOGGLE',
	ADMIN_SEARCH_FILTER_ROWS: 'ADMIN_SEARCH_FILTER_ROWS',
};

export const ACTION_FILTER_TYPES = {
	INVALID_INCLUDE: 'INVALID_INCLUDE',
	INVALID_EXCLUDE: 'INVALID_EXCLUDE',
	VALID_INCLUDE: 'VALID_INCLUDE',
	VALID_EXCLUDE: 'VALID_EXCLUDE',
	QUEUE_FILTER_PENDING: 'QUEUE_FILTER_PENDING',
	QUEUE_FILTER_APPLICATION: 'QUEUE_FILTER_APPLICATION',
};
